<div class='row'>
  <div class='col-6'>
    <p>
      A sample of your one-time message has been emailed to test recipients.
    </p>
    <p>
      Please review the test email carefully. If the email looks good, press
      FINISH.
    </p>
    <p>
      Email will be sent to the selected contacts. Press BACK to edit your
      one-time message and send another preview.
    </p>
  </div>
  <div *ngIf='messageData' class='col-6'>
    <p>
      Subject: <b>{{ messageData.subject }}</b>
    </p>
    <p>{{ renderGreeting() }}</p>
    <app-html-viewer [html]='messageData.message'></app-html-viewer>
  </div>
</div>
